/**
 * Course analytics page.
 */
import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { VAvatar, VButton, VText } from 'form';
import { BThumb } from 'components';
import { actionAppCourseDetailGet } from 'context/action';
import { useAsterController } from 'context';
import { shouldFetchCourseDetail } from 'utils/course';
import { getUserName } from 'utils/string';
import AnalysisProgress from './analysis.progress';
import AnalysisTime from './analysis.time';
import AnalysisBadge from './analysis.badge';
import AnalysisLog from './analysis.log';
import AnalysisModule from './analysis.module';
import AnalysisGrade from './analysis.grade';
import AnalysisReport from './analysis.report';

/**
 * Tabbed progress, grades, time, and report views for a course.
 */
const Analysis = () => {

  const { courseId } = useParams();

  const { t } = useTranslation('common');

  const [controller, dispatch] = useAsterController();
  const { structure, user, sessionHydrated, firstLoadPending } = controller;

  useEffect(() => {
    if (!shouldFetchCourseDetail(sessionHydrated, courseId, firstLoadPending)) return;
    actionAppCourseDetailGet(dispatch, courseId);
  }, [sessionHydrated, firstLoadPending, courseId, dispatch]);

  return <Box className="m-0 md:m-6 v-bg-body rounded-none md:rounded-md flex-1">
    <Box className="mx-auto">
      <Box className="p-4 md:p-8">
        <BThumb src={user.cover || `${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/admin/default-cover-2.svg`} error="" eager className="w-full h-64 rounded-md" />
        <Box className={`relative flex w-full md:justify-start flex-wrap items-end -mt-24 pl-0 md:pl-4`}>
          <VAvatar src={user.avatar} className="w-40 h-40" />
          <VText className="text-3xl md:text-4xl my-1 ml-4" div>{getUserName(user)}</VText>
          <Link to={`/course/${courseId}`} className="no-underline ml-auto">
            <VButton variant="text" color="secondary">{t("Back to course")}</VButton>
          </Link>
          <AnalysisReport />
        </Box>
      </Box>
      <Box className="px-6">
        <Box className="py-4 md:p-8">
          <VText className="md:text-4xl text-xl">{structure.course_title}</VText>

          <AnalysisBadge />

          <AnalysisTime />

          <AnalysisModule />

          <AnalysisProgress />

          <AnalysisGrade />

          <AnalysisLog />

        </Box>
      </Box>
    </Box>
  </Box>;

};

export default Analysis;